import { mergeClassName as e } from "../../utils/data.js";
import t from "./InputBox.module.js";
import { inputBoxClassName as n } from "./inputBoxClassName.js";
import { useMemo as r } from "react";
import { jsxDEV as i } from "react/jsx-dev-runtime";
//#region lib/components/Input/InputBox.tsx
var a = "/opt/render/project/src/shared-ui/lib/components/Input/InputBox.tsx";
function o({ hasError: o, active: s, prefix: c, suffix: l, boxProps: u, className: d, disabled: f, readOnly: p, readOnlyMuted: m = !0, ...h }) {
	let { className: g, ..._ } = u ?? {}, v = r(() => n({
		hasError: o,
		active: s,
		disabled: f,
		readOnly: p,
		readOnlyMuted: m
	}, g), [
		o,
		f,
		p,
		m,
		s,
		g
	]);
	return /* @__PURE__ */ i("div", {
		className: v,
		"data-disabled": f ?? void 0,
		..._,
		children: [
			c && /* @__PURE__ */ i("span", {
				className: t.adornment,
				"aria-hidden": !0,
				children: c
			}, void 0, !1, {
				fileName: a,
				lineNumber: 38,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ i("input", {
				className: e(t.input, d),
				disabled: f,
				readOnly: p,
				...h
			}, void 0, !1, {
				fileName: a,
				lineNumber: 42,
				columnNumber: 13
			}, this),
			l && /* @__PURE__ */ i("span", {
				className: t.adornment,
				"aria-hidden": !0,
				children: l
			}, void 0, !1, {
				fileName: a,
				lineNumber: 49,
				columnNumber: 17
			}, this)
		]
	}, void 0, !0, {
		fileName: a,
		lineNumber: 36,
		columnNumber: 9
	}, this);
}
//#endregion
export { o as InputBox };
